import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.css']
})
export class PasswordRecoveryComponent implements OnInit {

  email: string;
  message: string;
  errorMessage: string;

  constructor(
    public router: Router,
    public auth: AuthService
  ) {}

  ngOnInit() {
    document.body.style.background = '#f0f2f5';
    this.email = '';
    this.message = '';
  }

  onSubmit() {
    this.auth.sendRecoverEmail(this.email).subscribe(
      (result: any) => {
        this.message = result.message;
      },
      (error) => {
        this.errorMessage = error.error.message;
        console.error(error);
      });
  }
}
